import React from 'react'

const SadGrayIcon = () => {
    return (
        <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M36.0054 24.3423C31.1122 19.4491 24.4757 16.7002 17.5557 16.7002C10.6357 16.7002 4.89365 18.5546 0.000479644 23.4478" stroke="black" />
            <circle cx="6.15767" cy="4.56978" r="4.56978" fill="#5F5F5F" />
            <circle cx="29.8481" cy="4.56978" r="4.56978" fill="#5F5F5F" />
        </svg>
    )
}

export default SadGrayIcon